import React, { useContext, useEffect } from 'react';
import { Agreement } from '../types';
import { SettingsContext, GlobalErrorContext } from '../context';
import { useTranslation } from 'react-i18next';
import ChangePassword from './ChangePassword';
import AgreementsWizard from './AgreementsWizard';

/**
 * Wizard, several steps to get approve of agreements.
 * Used localStorage to save checkboxes that confirmed.
 * @param props
 */
export default function(props: {
  agreementsUnsigned: Agreement[]; // agreements that needed to confirm
  onSuccess: () => void;
}) {
  const { t } = useTranslation();
  const { setLayoutWidth } = useContext(SettingsContext);
  const { setGlobalError } = useContext(GlobalErrorContext);

  useEffect(() => {
    setLayoutWidth('lg');
  }, [setLayoutWidth]);

  return (
    <AgreementsWizard
      text={t('agreementsText')}
      agreementsUnsigned={props.agreementsUnsigned}
      steps={[
        {
          content: (
            <ChangePassword
              handleSuccess={() => props.onSuccess()}
              handleFailure={() => setGlobalError(t('agreementError'))}
              agreements={props.agreementsUnsigned}
              buttonText={t('agreementFinal')}
            />
          ),
          isNextDisabled() {
            return true;
          }
        }
      ]}
    />
  );
}
